import { render, staticRenderFns } from "./VPricerange.vue?vue&type=template&id=3bfe1d96"
import script from "./VPricerange.vue?vue&type=script&lang=js"
export * from "./VPricerange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports